module.exports = __webpack_public_path__ + "static/image/main/pc/banner-2-1.ver2_0_2.jpg?e255382e";